import { useRef, useState } from "react";
import "../../utils/main.css";
import "./index.css";
import BannerSignatureImg from "/src/assets/images/banner_signature.jpg";
import * as api from "../../utils/Api";
import { Button } from "primereact/button";
import CheckImg from "/src/assets/images/check.png";
import ErrorImg from "/src/assets/images/error.png";

export default function ValidateSignatureOrder() {
  const orderSignatureResponse = useRef<any>(null);
  const [codigoValidador, setCodigoValidador] = useState<string>("");
  const [orderNumber, setOrderNumber] = useState<number>(0);
  const [message, setMessage] = useState<string>("");
  const [colorText, setColorText] = useState<string>("");

  const fetchValidateSignatureOrder = async () => {
    try {
      const responseGetSignatureValidation =
        await api.GET_VALIDATION_DIGITAL_SIGN_PURCHASE_ORDER.getValidationDigitalSignPurchaseOrder(
          orderNumber,
          codigoValidador
        );
      if (responseGetSignatureValidation !== 404) {
        setMessage(
          "La firma de la órden de compra ha sido validada correctamente"
        );
        setColorText("white");
      } else {
        setMessage(
          "La firma de la órden de compra no tiene registros de validez"
        );
        setColorText("red");
      }
    } catch (error) {
      setMessage("La firma de la solicitud no tiene registros de validez");
      setColorText("red");
    }
  };

  const handleValidation = () => {
    fetchValidateSignatureOrder();
  };

  const doc = getComputedStyle(document.documentElement);

  return (
    <div style={{ margin: "50px", display: "inline-block", width: "1000px" }}>
      <div
        style={{
          backgroundColor: "white",
          height: "80px",
          alignContent: "center",
          color: doc.getPropertyValue("--primary-app-dark-color"),
        }}
      >
        <h2
          style={{
            marginLeft: "20px",
            fontSize: "20px",
            fontWeight: "400",
            color: "#535350",
          }}
        >
          Validación de firma de órdenes de compra
        </h2>
        <hr id="separator" style={{ width: "80%", marginBottom: "20px" }} />
      </div>

      <div className="wrap">
        <img width="1000px" height="500px" src={BannerSignatureImg} />
        <div
          style={{
            backgroundColor: "white",
            alignContent: "center",
            color: doc.getPropertyValue("--primary-app-dark-color"),
            display: "flex",
            flexDirection: "row",
            padding: "40px",
            justifyContent: "center",
          }}
        >
          <label style={{ marginRight: "10px" }}>
            Número de orden de compra:{" "}
          </label>
          <input
            type="text"
            value={orderNumber}
            onChange={(e) => setOrderNumber(Number(e.target.value))}
            style={{ marginRight: "20px" }}
          />

          <div>
            <label style={{ marginRight: "10px" }}>Código validador: </label>
            <input
              type="text"
              value={codigoValidador}
              onChange={(e) => setCodigoValidador(e.target.value)}
              style={{ marginRight: "20px" }}
            />
          </div>
        </div>

        <div>
          <Button
            className="buttonformrow"
            style={{ margin: "30px" }}
            onClick={handleValidation}
          >
            VALIDAR
          </Button>
        </div>
        {colorText !== "" ? (
          <img
            style={{ width: "36px", height: "36px" }}
            src={colorText !== "red" ? CheckImg : ErrorImg}
          />
        ) : null}
        <p
          style={{
            fontSize: "12px",
            color: colorText,
          }}
        >
          {message}
        </p>
      </div>
    </div>
  );
}
